Vue.component('send-invite-modal', require('./SendInviteModal').default);
Vue.component('recent-invite-list', require('./RecentInviteList').default);
Vue.component('recent-invite-list-item', require('./RecentInviteListItem').default);
Vue.component('recent-messages-list', require('./RecentMessagesList').default);
Vue.component('recent-messages-list-item', require('./RecentMessagesListItem').default);
Vue.component('invite-location-info', require('./InviteLocationInfo').default);
Vue.component('invited-company', require('./InvitedCompany').default);
Vue.component('send-bulk-invites-modal', require('./SendBulkInvitesModal').default);
Vue.component('delete-scheduled-invites-modal', require('./DeleteScheduledInvitesModal').default);
Vue.component('send-group-invites-modal', require('./SendGroupInvitesModal').default);
Vue.component('invitation-history', require('./InvitationHistory').default);
